/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CloneFragmentDetailMutationRequest, CloneFragmentDetailMutationResponse, CloneFragmentDetailPathParams } from "../models/CloneFragmentDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { cloneFragmentDetail } from "../axios/cloneFragmentDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const cloneFragmentDetailMutationKey = () => ["web-app-bff-api", { url: '/fragments/:id/clone' }] as const

export type CloneFragmentDetailMutationKey = ReturnType<typeof cloneFragmentDetailMutationKey>

export function cloneFragmentDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CloneFragmentDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = cloneFragmentDetailMutationKey()
        return mutationOptions<CloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: CloneFragmentDetailPathParams["id"], data: CloneFragmentDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return cloneFragmentDetail(id, data, config)
          },
        })

}

/**
 * @summary Clone a fragment
 * {@link /fragments/:id/clone}
 */
export function useCloneFragmentDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<CloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: CloneFragmentDetailPathParams["id"], data: CloneFragmentDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CloneFragmentDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? cloneFragmentDetailMutationKey()

          const baseOptions = cloneFragmentDetailMutationOptions(config) as UseMutationOptions<CloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: CloneFragmentDetailPathParams["id"], data: CloneFragmentDetailMutationRequest}, TContext>
          

          return useMutation<CloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: CloneFragmentDetailPathParams["id"], data: CloneFragmentDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: CloneFragmentDetailPathParams["id"], data: CloneFragmentDetailMutationRequest}, TContext>
      
}